import { CustomerJobRole } from "./customer-job-role.model";

export class CustomerContact {
	id?: string;
	firstName?: string;
	lastName?: string;
	email?: string;
	phone?: string;
	fax?: string;
	mobile?: string;
	linkedCustomerAddressId?: number;
	address?: string;
	city?: string;
	province?: string;
	country?: string;
	zipCode?: string;
	jobRole?: CustomerJobRole;
	jobTitle?: string;
	default?: Boolean;
	proofContact?: Boolean;
	materialContact?: Boolean;
}
